module.exports = "/packs/as_mv_top-f0d074d6cabbc038980ea0c16270e0e3.png";